var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('SchoolHeader'),_c('SchoolBanner'),_c('section',{staticClass:"main-content"},[_c('div',{staticClass:"content-container"},[_c('NewsSection'),_c('StudentsSection'),_c('TeachersSection'),_c('HomeBottomTu')],1)]),_c('FooterNav')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }